export default __webpack_public_path__ + "static/media/RCBC.21a20d58.png";